import React from 'react';
import './home.css';

export default function Home() {
  return (
    <div>
      <div className="home">
        <h1>Welcome</h1>
        <div className="desc">
          Math Magicians is a website for all fans of mathematics. Make simple
          calculations and view some of your favorite math quotes!
        </div>
      </div>
    </div>
  );
}
